import React from "react";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import Skeleton from "src/components/Skeleton";

const LAYOUTS = {
	stacked: {
		wrapper: "",
		label: "",
	},
	horizontal: {
		wrapper: "flex flex-row gap-2",
		label: "flex items-center w-full max-w-[100px]",
	},
};
export type FormGroupLayout = keyof typeof LAYOUTS;

interface FormGroupProps {
	type?: string;
	label?: string;
	error?: any | boolean;
	valid?: string | boolean | number;
	loading?: boolean;
	help?: string;
	children?: any;
	className?: string;
	optional?: boolean;
	ref?: any;
	name?: string;
	noMarginBottom?: boolean;
	disabled?: boolean;
	layout: FormGroupLayout;
}

const FormGroup = ({
	type,
	label,
	error,
	valid,
	loading,
	help,
	className,
	children,
	name,
	noMarginBottom,
	optional,
	layout,
}: FormGroupProps) => {
	const { t } = useTranslation("form", {
		keyPrefix: "form-group",
	});
	const classes = LAYOUTS[layout];
	// const Label = layout === "horizontal" ? "span" : "span";

	return (
		<div
			className={`${className || ""} ${classes.wrapper} ${
				!noMarginBottom && "mb-4"
			} `}
		>
			{label && (
				<label
					className={`flex text-left items-center text-[16px] mb-[4px] ${classes.label}`}
				>
					{label && <span className="font-regular">{label}</span>}
					{valid && !error && <i className="ml-2 fal fa-check"></i>}
					{help && !valid && (
						<span className="ml-2">
							<i
								data-tip
								data-for={`tooltip-${name}`}
								className="fal fa-info-circle"
							></i>
							<ReactTooltip id={`tooltip-${name}`} effect="solid">
								{help}
							</ReactTooltip>
						</span>
					)}
					{optional && (
						<small className="ml-2">({t("optional")})</small>
					)}
				</label>
			)}
			<div className="flex w-full relative rounded-md">
				{children}
				{loading && (
					<div className="absolute top-0 flex items-center right-4 bottom-0">
						<div className="base-loader"></div>
					</div>
				)}
				{!label && valid && !error ? (
					<div className="flex pointer-events-none justify-center items-center absolute top-0 bottom-0 right-4">
						<div className="fas fa-check text-sm"></div>
					</div>
				) : (
					false
				)}
			</div>
			{error && <p className="input-error">{error}</p>}
		</div>
	);
};

FormGroup.defaultProps = {
	layout: "stacked",
};

interface LoadingProps {
	children?: any;
}

const Loading = ({ children }: LoadingProps) => {
	return (
		<div className="flex flex-col gap-2">
			<Skeleton className="w-16 h-4" />
			<div className="flex flex-col flex-1 w-full">{children}</div>
		</div>
	);
};

FormGroup.Loading = Loading;

export default FormGroup;
